import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/Logo";

const NAV_LINKS = [
  { label: "Services", href: "#services", testid: "nav-services-link" },
  { label: "About", href: "#about", testid: "nav-about-link" },
  { label: "Why Us", href: "#why-us", testid: "nav-why-us-link" },
  { label: "Process", href: "#process", testid: "nav-process-link" },
  { label: "Contact", href: "#contact", testid: "nav-contact-link" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#060B14]/85 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="brand-link" className="flex items-center gap-3 group">
          <Logo className="h-10 w-10" />
          <div className="flex flex-col leading-none">
            <span className="font-display font-bold text-lg tracking-tight">HRN NETWORKS</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6] mt-1">
              networking · engineering
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="link-underline text-sm font-medium text-[#A0B2C6] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+919028442833"
            data-testid="nav-phone-link"
            className="flex items-center gap-2 text-sm text-[#A0B2C6] hover:text-white transition"
          >
            <Phone size={14} className="text-[#FF6B00]" />
            +91 90284 42833
          </a>
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="bg-[#FF6B00] hover:bg-[#FF8533] text-white px-5 py-2.5 text-sm font-semibold tracking-wide transition-all shadow-[0_0_15px_rgba(255,107,0,0.25)] hover:shadow-[0_0_25px_rgba(255,107,0,0.5)]"
          >
            Request a Quote
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="lg:hidden border-t border-white/5 bg-[#060B14]/95 backdrop-blur-xl">
          <div className="px-5 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className="text-base text-[#A0B2C6] hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-cta-button-mobile"
              className="bg-[#FF6B00] text-white text-center px-5 py-3 font-semibold tracking-wide mt-2"
            >
              Request a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
